// extracted by mini-css-extract-plugin
module.exports = {"bundles":"Bundles_bundles__uKClU"};